import { render, staticRenderFns } from "./ColorPickerComponent.vue?vue&type=template&id=1f918741"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports